var MySettingsEditPasswordForm = ( function($) {

    var MySettingsEditPasswordForm = function(options) {
        this.init(options);
    };

    var Self = MySettingsEditPasswordForm;
    Self.className = 'MySettingsEditPasswordForm';
    var Parent = ActionformAbstract;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;
        Parent.prototype.init.call(that, options);

        that.__initValidation();
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};
        
        // CONST
        that.locales = options['locales'] || {};
        that.password_min_length = options['password_min_length'];
        that.password_max_length = options['password_max_length'];
        that.name = {
            password: 'password',
            password_repeat: 'password_repeat'
        }

        that.selectors = {
            form: '.js-form-edit-password',
            next_action: '',
            previous_action: '',
        };

        that.url = $.sa.build_url('my/settings/edit-password');
        that.method = 'POST';

        that.has_success_screen = false;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.onDoneSubmitHandlers = function () {
        var that = this,
            handlers_default = Parent.prototype.onDoneSubmitHandlers.call(that),
            handlers_custom = Object.assign({}, handlers_default);

        handlers_custom.goToNext = function (response) {
            response = response || {};
            if (response.status === 'ok' && response.data === true) {
                Parent.prototype.closeModal.call(that);
                $.sa.notifier.show({
                    title: that.locales['edit_password_success_notify_title'],
                    notifier_class: $.sa.notifier.class.success,
                    time: 4000,
                });
                return true;
            }
            return false;
        };

        return handlers_custom;
    };

    Self.prototype.__initValidation = function() {
        var that = this,
            $password_inputs = that.__getPasswordInputs();

        $password_inputs.on('input', function () {
            that.__validateEmpty($(this));
        });
        $password_inputs.on('blur', function() {
            that.__validateLength($(this));
            that.__validateMatch();
        });
    };

    Self.prototype.__validateEmpty = function($input_password) {
        var that = this,
            password_value = $input_password.val().trim(),
            error_text = $input_password.data('error-empty'),
            is_valid = password_value.length > 0;

        that.__handleValidationResult($input_password, is_valid, error_text);
        that.isValidForm();
    };

    Self.prototype.__validateLength = function($input_password) {
        var that = this,
            password_value = $input_password.val().trim(),
            error_max_limit_characters = $input_password.data('error-max-limit-characters'),
            error_min_limit_characters = $input_password.data('error-min-limit-characters');

        if (password_value.length === 0) {
            return false;
        }

        if (password_value.length > that.password_max_length) {
            that.__handleValidationResult($input_password, false, error_max_limit_characters);
        } else if (password_value.length < that.password_min_length) {
            that.__handleValidationResult($input_password, false, error_min_limit_characters);
        } else {
            that.__handleValidationResult($input_password, true);
        }

        that.isValidForm();
    };

    Self.prototype.__validateMatch = function() {
        var that = this,
            $input_password = that.__getPasswordInput(),
            $input_password_repeat = that.__getPasswordRepeatInput(),
            password_value = $input_password.val().trim(),
            password_repeat_value = $input_password_repeat.val().trim(),
            password_error_text = $input_password.data('error-mismatch'),
            password_repeat_error_text = $input_password_repeat.data('error-mismatch');

        if (password_value.length === 0 || password_repeat_value.length === 0
            || password_value.length > that.password_max_length
            || password_value.length < that.password_min_length
            || password_repeat_value.length > that.password_max_length
            || password_repeat_value.length < that.password_min_length
        ) {
            return false;
        }

        var is_valid = password_value === password_repeat_value;
        that.__handleValidationResult($input_password, is_valid, password_error_text);
        that.__handleValidationResult($input_password_repeat, is_valid, password_repeat_error_text);

        that.isValidForm();
    };

    Self.prototype.__getPasswordInputs = function() {
        var that = this;

        return Parent.prototype.getFormInput.call(that, that.name.password)
            .add(Parent.prototype.getFormInput.call(that, that.name.password_repeat));
    };

    Self.prototype.__getPasswordInput = function() {
        var that = this;

        return Parent.prototype.getFormInput.call(this, that.name.password);
    };

    Self.prototype.__getPasswordRepeatInput = function() {
        var that = this;

        return Parent.prototype.getFormInput.call(this, that.name.password_repeat);
    };

    Self.prototype.__handleValidationResult = function($input, is_valid, error_text = '') {
        if (!is_valid) {
            UIInput.prototype.setError($input, error_text, true);
        } else {
            UIInput.prototype.clearError($input);
        }
    };

    Self.prototype.isValidForm = function () {
        var that = this,
            $inputs = Parent.prototype.getFormInputs.call(that),
            $input_password = Parent.prototype.getFormInput.call(that, that.name.password),
            $input_password_repeat = Parent.prototype.getFormInput.call(that, that.name.password_repeat),
            password_value = $input_password.val().trim(),
            password_repeat_value = $input_password_repeat.val().trim(),
            is_valid = true;

        $inputs.find('input').each(function () {
            var $input = $(this),
                password_value = $input.val().trim();
            if (password_value.length === 0) {
                is_valid = false;
                return false;
            }

            if (($input.attr('name') === that.name.password || $input.attr('name') === that.name.password_repeat)
                && (password_value.length > that.password_max_length || password_value.length < that.password_min_length)
            ) {
                is_valid = false;
                return false;
            }
        });

        if (is_valid && password_value.length > 0 && password_repeat_value.length > 0 && password_value !== password_repeat_value) {
            is_valid = false;
        }

        that.toggleSubmitButtonAvailability(is_valid);
        
        return is_valid;
    };

    return Self;
})(jQuery);